import React from 'react'
import '../Styles/Fixxcapital.css'
import Introduction from '../Components/Introduction'
import fixxcapital from '../Assets/logo-fixxcapital-white.webp'
import Services from '../Components/Services'
import CardServices from '../Components/CardServices'
import GeographicPresence from '../Components/GeographicPresence'
import logoCVM from '../Assets/logo-cvm.webp'

function FixxCapital({ id }) {
  return (
    <section id={id}>
      <div id="introduction-fixxcapital" className="padding-50">
        <Introduction
          srcLogo={fixxcapital}
          altProduct="Fixx Capital"
          description="A Fixxcapital, inscrita sob o CNPJ 55.505.378/0001-39, atua no setor de securitização de créditos, ou seja, ela transforma fluxos de crédito (dívidas) em títulos que podem ser comercializados no mercado financeiro. Este processo permite que empresas e instituições financeiras liberem capital para novas operações, ao vender seus créditos futuros. A securitização é uma prática comum em mercados maduros, trazendo maior liquidez para empresas que desejam monetizar seus recebíveis."
          color="white"
        />
        <div id="container-cvm" className="flex-center flex__gap-20">
          <p className="text-white">CVM 000116-3</p>
          <a
            href="https://www.gov.br/cvm/pt-br"
            target="_blank"
            rel="noreferrer"
          >
            <div className="cvm-logo">
              <img src={logoCVM} alt="Logo CVM" />
            </div>
          </a>
        </div>
      </div>

      <Services backgroundColor="white" colorTitle="#090A0A">
        <CardServices
          title="Flexibilidade na securitização"
          description="A empresa oferece soluções personalizadas de securitização de créditos, adaptando-se às necessidades específicas de cada cliente, seja ele de grande porte ou de pequeno e médio porte. Isso inclui a estruturação de operações de securitização para diferentes setores, como imobiliário, infraestrutura, comercial e industrial."
          backgroundColor="#102841"
          colorTitle="white"
          colorContent="white"
          height="330px"
        />

        <CardServices
          title="Liquidez Imediata"
          description="Um dos principais atrativos da securitização de créditos é a geração de liquidez imediata para as empresas que vendem seus créditos. A FIXXCAPITAL facilita essa transação de maneira ágil, o que possibilita que as empresas clientes invistam em novos projetos ou reduzam seus passivos financeiros."
          backgroundColor="#102841"
          colorTitle="white"
          colorContent="white"
          height="330px"
        />

        <CardServices
          title="Processo ágil e seguro"
          description="Com a crescente adoção de tecnologias no setor financeiro, a FIXXCAPITAL se posiciona como uma empresa inovadora, utilizando soluções tecnológicas que tornam o processo de securitização mais eficiente e seguro. A digitalização dos processos permite maior transparência e redução de custos operacionais."
          backgroundColor="#102841"
          colorTitle="white"
          colorContent="white"
          height="330px"
        />

        <CardServices
          title="Atendimento especializado"
          description="O setor de securitização de créditos exige uma compreensão detalhada das leis e regulamentações que envolvem esses processos. A FIXXCAPITAL conta com equipes especializadas que prestam assessoria personalizada aos seus clientes, garantindo que todas as operações estejam em conformidade com as normas legais e regulatórias, especialmente com órgãos como a CVM e o Banco Central."
          backgroundColor="#102841"
          colorTitle="white"
          colorContent="white"
          height="330px"
        />

        <CardServices
          title="Diversificação de Títulos"
          description="Além da securitização tradicional, a FIXXCAPITAL pode auxiliar na criação de títulos financeiros que podem ser vendidos em diferentes mercados, como Certificados de Recebíveis Imobiliários (CRI) e Certificados de Recebíveis do Agronegócio (CRA). Essa diversificação é atrativa tanto para investidores quanto para as empresas que buscam monetizar seus créditos."
          backgroundColor="#102841"
          colorTitle="white"
          colorContent="white"
          height="330px"
        />
      </Services>

      <GeographicPresence
        description={
          <>
            A Fixxcapital possui <span>sede no estado do Paraná</span>, mas sua
            atuação no mercado de securitização de créditos ultrapassa
            fronteiras geográficas, devido à natureza digital e financeira dos
            seus serviços. Com a transformação digital, a Fixxcapital pode
            oferecer seus{' '}
            <span>
              serviços de securitização para empresas em todo o Brasil
            </span>
            , operando de forma eficiente em mercados financeiros amplamente
            conectados.
          </>
        }
      />
    </section>
  )
}

export default FixxCapital
